// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2yPpB","errorLogs":"styles_errorLogs__26Rd4"};